export enum SelectSize {
  Small = 'small',
  Default = 'default',
  Large = 'large'
}
